import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { ConnectedProps, connect } from "react-redux";
import collectionRoutes from "us.collection/routes";
import Common from "us.common";
import { ConfigurationProvider } from "us.common/ConfigurationContext";
import { UnauthenticatedTemplate } from "@azure/msal-react";
import { SignalRProvider } from "us.common/SignalRProvider";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { RootState } from "us.helper/types";
import { FeatureFlagProvider } from "us.common/FeatureFlagContext";

import { DrawerProvider } from "us.common/context";
import { useAuth } from "us.helper/hooks/useAuth";
import { Loader, LoginRedirect } from "us.common/components";
import { NavigationListener } from "us.helper/navigation";

const { Page404, AppLayout, ConfigProvider } = Common.Components;

const App: React.FC<PropsFromRedux> = ({ currentLanguage }) => {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return (
      <UnauthenticatedTemplate>
        <BrowserRouter
          future={{
            v7_relativeSplatPath: true,
          }}
        >
          <LoginRedirect />
        </BrowserRouter>
      </UnauthenticatedTemplate>
    );
  }

  return (
    <AuthenticatedTemplate>
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
        }}
      >
        <NavigationListener />
        <ConfigurationProvider>
          <FeatureFlagProvider>
            <DrawerProvider>
              <SignalRProvider>
                <AppLayout>
                  <ConfigProvider locale={currentLanguage}>
                    <Routes>
                      {collectionRoutes()}
                      <Route path="*" element={<Page404 />} />
                    </Routes>
                  </ConfigProvider>
                </AppLayout>
              </SignalRProvider>
            </DrawerProvider>
          </FeatureFlagProvider>
        </ConfigurationProvider>
      </BrowserRouter>
    </AuthenticatedTemplate>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    currentLanguage: state.common.currentLanguage,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(App);
